import type { QueryClient } from "@tanstack/react-query";

/**
 * Every cached read that shows a campaign's name, status, dates or recipients, by key prefix:
 * My Campaigns (`["campaigns", params]`), the dashboard panels (`["dashboard", …]`), the Impact
 * Report / Thank You Notes campaign pickers (`["campaignOptions", …]`) and Manage Contacts
 * (`["campaignContacts", id]`).
 */
const CAMPAIGN_READ_KEYS = [
  ["campaigns"],
  ["dashboard"],
  ["campaignOptions"],
  ["campaignContacts"],
];

/**
 * Mark every campaign read stale after a write that changes a campaign — save, launch, clone,
 * rename, delete. One list, so a write cannot refresh My Campaigns and leave the dashboard or a
 * picker serving the old row for the global 5-minute staleTime (GFG-378). An inactive query is
 * only marked stale, so calling this on every builder autosave costs no request.
 */
export function invalidateCampaignReads(queryClient: QueryClient): void {
  for (const queryKey of CAMPAIGN_READ_KEYS) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
